/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentDocument } from "./ShipmentDocument";
import {
  ShipmentDocumentFromJSON,
  ShipmentDocumentFromJSONTyped,
  ShipmentDocumentToJSON,
  ShipmentDocumentToJSONTyped,
} from "./ShipmentDocument";

/**
 *
 * @export
 * @interface ShipmentDocumentVisibility
 */
export interface ShipmentDocumentVisibility {
  /**
   *
   * @type {ShipmentDocument}
   * @memberof ShipmentDocumentVisibility
   */
  shipmentDocument: ShipmentDocument;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentDocumentVisibility
   */
  visibleToCustomer: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentDocumentVisibility
   */
  visibleToCustomerByDefault: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentDocumentVisibility
   */
  canOverrideVisibility: boolean;
}

/**
 * Check if a given object implements the ShipmentDocumentVisibility interface.
 */
export function instanceOfShipmentDocumentVisibility(
  value: object,
): value is ShipmentDocumentVisibility {
  if (!("shipmentDocument" in value) || value["shipmentDocument"] === undefined)
    return false;
  if (
    !("visibleToCustomer" in value) ||
    value["visibleToCustomer"] === undefined
  )
    return false;
  if (
    !("visibleToCustomerByDefault" in value) ||
    value["visibleToCustomerByDefault"] === undefined
  )
    return false;
  if (
    !("canOverrideVisibility" in value) ||
    value["canOverrideVisibility"] === undefined
  )
    return false;
  return true;
}

export function ShipmentDocumentVisibilityFromJSON(
  json: any,
): ShipmentDocumentVisibility {
  return ShipmentDocumentVisibilityFromJSONTyped(json, false);
}

export function ShipmentDocumentVisibilityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentDocumentVisibility {
  if (json == null) {
    return json;
  }
  return {
    shipmentDocument: ShipmentDocumentFromJSON(json["shipmentDocument"]),
    visibleToCustomer: json["visibleToCustomer"],
    visibleToCustomerByDefault: json["visibleToCustomerByDefault"],
    canOverrideVisibility: json["canOverrideVisibility"],
  };
}

export function ShipmentDocumentVisibilityToJSON(
  json: any,
): ShipmentDocumentVisibility {
  return ShipmentDocumentVisibilityToJSONTyped(json, false);
}

export function ShipmentDocumentVisibilityToJSONTyped(
  value?: ShipmentDocumentVisibility | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentDocument: ShipmentDocumentToJSON(value["shipmentDocument"]),
    visibleToCustomer: value["visibleToCustomer"],
    visibleToCustomerByDefault: value["visibleToCustomerByDefault"],
    canOverrideVisibility: value["canOverrideVisibility"],
  };
}
